function pick(item, camel, upper) {
    if (!item) return undefined
    if (item[camel] !== undefined && item[camel] !== null) return item[camel]
    return item[upper]
}

/** Unidades base que consume 1 línea del artículo (cantidad × este factor) */
export function obtenerEmpaque(item) {
    const alq = pick(item, 'alq_cant_uso_diario', 'ALQ_CANT_USO_DIARIO')
    if (alq != null && alq !== '') {
        const n = Number(alq)
        return n > 0 ? n : 1
    }
    const empaque = Number(pick(item, 'cant_empaq', 'CANT_EMPAQ') || 1)
    return empaque > 0 ? empaque : 1
}

/**
 * Stock del artículo expresado en unidades base.
 * - Con ALQ_CANT_USO_DIARIO: DISPONIBLE está en empaques de alquiler → se multiplica por ALQ.
 * - Sin ALQ: DISPONIBLE ya viene en unidades sueltas (máx. packs = DISPONIBLE / CANT_EMPAQ).
 */
export function obtenerDisponibleEnUnidades(item) {
    const disp = Number(pick(item, 'disponible', 'DISPONIBLE') || 0)
    if (!Number.isFinite(disp)) {
        return 0
    }

    const alq = pick(item, 'alq_cant_uso_diario', 'ALQ_CANT_USO_DIARIO')
    if (alq != null && alq !== '') {
        return disp * (Number(alq) || 1)
    }

    return disp
}

export function obtenerGrupoStockId(item) {
    return pick(item, 'peso', 'PESO') || null
}

export function cantidadTotalGrupoEnCarrito(carrito, grupoId, codArtExcluir = null) {
    if (!grupoId) {
        return 0
    }
    return carrito.reduce((total, artCarrito) => {
        if (artCarrito.cod_art === codArtExcluir) {
            return total
        }
        const grupoCarrito = obtenerGrupoStockId(artCarrito)
        if (grupoCarrito !== grupoId) {
            return total
        }
        return total + (Number(artCarrito.cantidad) * obtenerEmpaque(artCarrito))
    }, 0)
}

/** Stock compartido del grupo en unidades base (máximo entre variantes conocidas) */
export function obtenerDisponibleGrupoEnUnidades(item, carrito) {
    const grupoId = obtenerGrupoStockId(item)
    if (!grupoId) {
        return obtenerDisponibleEnUnidades(item)
    }

    const candidatos = [obtenerDisponibleEnUnidades(item)]
    carrito.forEach(artCarrito => {
        if (obtenerGrupoStockId(artCarrito) === grupoId) {
            candidatos.push(obtenerDisponibleEnUnidades(artCarrito))
        }
    })
    return Math.max(...candidatos, 0)
}

export function puedeAsignarCantidadPorGrupo(item, cantidadDeseada, carrito) {
    const cantidad = Number(cantidadDeseada)
    if (!Number.isFinite(cantidad) || cantidad <= 0) {
        return false
    }

    const grupoId = obtenerGrupoStockId(item)
    const empaque = obtenerEmpaque(item)
    const cantidadDeseadaUnidades = cantidad * empaque
    const disponibleUnidades = grupoId
        ? obtenerDisponibleGrupoEnUnidades(item, carrito)
        : obtenerDisponibleEnUnidades(item)

    if (!grupoId) {
        return cantidadDeseadaUnidades <= disponibleUnidades
    }

    const codArt = pick(item, 'cod_art', 'COD_ART')
    const totalGrupoSinActual = cantidadTotalGrupoEnCarrito(carrito, grupoId, codArt)
    return (totalGrupoSinActual + cantidadDeseadaUnidades) <= disponibleUnidades
}

export function disponibleGrupoParaItem(item, carrito) {
    const grupoId = obtenerGrupoStockId(item)
    const disponibleUnidades = grupoId
        ? obtenerDisponibleGrupoEnUnidades(item, carrito)
        : obtenerDisponibleEnUnidades(item)

    if (!grupoId) {
        return disponibleUnidades
    }

    const codArt = pick(item, 'cod_art', 'COD_ART')
    const totalGrupoSinActual = cantidadTotalGrupoEnCarrito(carrito, grupoId, codArt)
    return Math.max(0, disponibleUnidades - totalGrupoSinActual)
}

function tieneAlquiler(item, stockRow = {}) {
    const alq = pick(item, 'alq_cant_uso_diario', 'ALQ_CANT_USO_DIARIO')
        ?? pick(stockRow, 'alq_cant_uso_diario', 'ALQ_CANT_USO_DIARIO')
    return alq != null && alq !== ''
}

function factorEmpaqueSinAlquiler(item, stockRow = {}) {
    const empaque = Number(
        pick(stockRow, 'cant_empaq', 'CANT_EMPAQ')
        ?? pick(item, 'cant_empaq', 'CANT_EMPAQ')
        ?? 1
    )
    return !empaque ? 1 : empaque
}

/**
 * Cantidad pedida comparable con DISPONIBLE de getCheckPrecioStock / getPrecioStock
 * (misma regla que factorEmpaqueCalculo del BE):
 * - Con ALQ_CANT_USO_DIARIO: no se multiplica
 * - Sin ALQ: cantidad * CANT_EMPAQ
 */
export function cantidadComparableConDisponibleApi(item, stockRow = {}) {
    const cantidad = Number(item.cantidad) || 0
    if (tieneAlquiler(item, stockRow)) {
        return cantidad
    }
    return cantidad * factorEmpaqueSinAlquiler(item, stockRow)
}

/**
 * Convierte DISPONIBLE de getCheckPrecioStock a cantidad del carrito
 * (unidades de pedido / empaques de venta).
 */
export function disponibleApiComoCantidadPedido(item, stockRow = {}) {
    const disponible = Number(pick(stockRow, 'disponible', 'DISPONIBLE') || 0)
    if (!Number.isFinite(disponible) || disponible <= 0) {
        return 0
    }
    if (tieneAlquiler(item, stockRow)) {
        return Math.floor(disponible)
    }
    return Math.floor(disponible / factorEmpaqueSinAlquiler(item, stockRow))
}

/** Cantidad en unidades/base para logs y CANT_NO_PROC (misma regla ALQ del BE). */
export function cantidadEnUnidadesPedido(item) {
    return cantidadComparableConDisponibleApi(item)
}
